// ADD WORDPRESS URL
// Example: https://abc15100.sg-host.com (Without / at the end)
export const getWordpressData = (institutionCode) => {
	console.log(institutionCode);
	switch (institutionCode) {
		case 'TESTING':
			return 'https://abc15100.sg-host.com';
		case 'ABC':
			return 'https://integrationportal.americanbusiness.college'; // Modify this to the real URL, This is for testing.
		default:
			return '';
	}
};
